import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useDemoData } from "@mui/x-data-grid-generator";
import { Box, Typography } from "@mui/material";

export default function Product() {
  const { data, loading } = useDemoData({
    dataSet: "Commodity",
    rowLength: 100,
    maxColumns: 6,
  });

  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.paper,
        boxShadow: "0px 8px 13px -3px rgba(0, 0, 0, 0.07)",
        p: "20px 20px 5px",
      }}
    >
      <Typography variant="h4" sx={{ pb: 2 }}>
        {" "}
        Products
      </Typography>

      <Box
        sx={{
          height: 450,
          width: "100%",
          mb: (theme) => theme.spacing(3),
        }}
      >
        <DataGrid
          {...data}
          loading={loading}
          slots={{ toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  );
}
